@if (loading()) {
    <div class="container-loading">
        <ra-loading [message]="'order.listClients.loading' | translate"/>
    </div>
}
@else {
    <!-- Description -->
    <p class="ra-label-s content-secondary description-message">{{ 'order.listClients.hint' | translate }}</p>

    <!-- Input search + novo cliente -->
    <div class="container-input-search">
        <ra-input
            [id]="'input-search-order-list-clients'"
            [placeholder]="'order.listClients.searchPlaceholder' | translate"
            [formControl]="searchControl"
            [showRequiredOrOptional]="false"
        />

        <ra-button
            [id]="'button-new-client-order-list-clients'"
            [icon]="'add'"
            [label]="'order.listClients.newClient' | translate"
            [type]="'primary-light'"
            [disabled]="loadingCreate()"
            (click)="orderCreateService.showCreateClient.set(true)"
        />
    </div>

    @if (clientsFiltered().length == 0) {
        <div class="container-empty">
            <ra-empty [message]="'order.listClients.emptyMessage' | translate"/>
        </div>
    }
    @else {
        <!-- Clients list -->
        <div class="container-clients-list">
            @for (client of clientsFiltered(); track client._id; let i = $index) {
                <ra-fillet 
                    [id]="'fillet-client-' + i"
                    [icon]="'profile-2user'"
                    [title]="client.name"
                    [active]="orderCreateService.client()?._id == client._id"
                    [clickMessage]="'order.listClients.selectHint' | translate"
                    [description]="(client.address | addressFormat) || ('order.listClients.addressNotFound' | translate)"
                    (click)="orderCreateService.client.set(client)"
                />
            }
        </div>
    }

    <!-- Actions -->
    <div class="dialog-actions">
        <ra-button 
            [id]="'button-back-order-list-clients'"
            [label]="'order.common.back' | translate"
            [type]="'primary-outline'"
            [disabled]="loadingCreate()"
            (click)="orderCreateService.previousStep()"
        />

        <ra-button 
            [id]="'button-create-order-list-clients'"
            [label]="'order.listClients.submit' | translate"
            [type]="'primary'"
            [disabled]="orderCreateService.client() == null"
            [loading]="loadingCreate()"
            (click)="nextStep()"
        />  
    </div>
}
